import React from 'react';
import type {VariantProps} from 'class-variance-authority';
import {cva} from 'class-variance-authority';

import {cn} from '@/utils/tailwind';

const responseMessage = cva(['border', 'py-6', 'px-8', 'rounded-lg'], {
	variants: {
		success: {
			true: [
				'text-success-text-default',
				'bg-success-surface-tinted',
				'border-success-border-strong',
			],
			false: [
				'text-danger-text-default',
				'bg-danger-surface-tinted',
				'border-danger-border-strong',
			],
		},
	},
});

type ResponseMessageProps = VariantProps<typeof responseMessage> & {
	message: string;
};

export const ResponseMessage = ({success, message}: ResponseMessageProps) => {
	return (
		<div className={cn(responseMessage({success}))} role="status">
			{message}
		</div>
	);
};
